
import { getFileUploadURL } from '@/utils/constant'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import OSS from 'ali-oss'
import { getOssPlicy } from '@/api/user'
import { getWebpFileByImageFile } from '@/utils/file'

@Component({
  name: 'Picsloader'
})
export default class extends Vue {
  @Prop() private attachUrl!: any
  private apiUrl: string = getFileUploadURL() + '/upload-file'
  private fileList: any[] = []
  private fileListNew: any[] = []
  private dialogVisible: boolean = false
  private dialogImageUrl = ''
  private ossParams: any = {}
  private uploadDir: any = ''
  private file: any

  get language() {
    return AppModule.language
  }

  // 移除图片
  private handleRemove(file, fileList) {
    if (this.language === 'en') {
      this.$message.success('Remove the success！')
    } else if (this.language === 'zh_cn') {
      this.$message.success('删除成功！ ')
    } else if (this.language === 'zh_tw') {
      this.$message.success('刪除成功！')
    }
    this.fileList = fileList
    this.$emit('uploadOk', this.fileList)
  }

  // 预览图片
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }

  // 上传成功
  private handleAvatarSuccess(res, file) {
    this.$emit('uploadOk', res.file_path)
    // const obj = {
    //   file
    // }
    // this.uploadFn(obj)
    return false
  }

  private uploadFn() {
    const form = new FormData()
    form.append('file', this.file, this.file.name)
    const random_name = this.randomFileName(this.file, 6)
    const oss = new OSS(this.ossParams)
    oss
      .put(random_name, this.file)
      .then(({ res }) => {
        this.fileListNew.push(...res.requestUrls)
        this.fileList.push({
          url: res.requestUrls[0]
        })
        this.$emit('uploadOk', this.fileList)
      })
      .catch(e => {
        console.log(e, '失败了')
      })
  }

  // 随机生成文件名
  private randomFileName(file, len) {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678'
    let maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    let fileName =
      this.uploadDir +
      pwd +
      '_' +
      new Date().getTime() +
      '.' +
      file.name.split('.').pop()
    return fileName
  }

  // 上传之前验证文件大小
  private async beforeAvatarUpload(file) {
    this.file = await getWebpFileByImageFile(file)
    const isLt5M = file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      if (this.language === 'en') {
        this.$message.error('File size should not exceed 5MB!')
      } else if (this.language === 'zh_cn') {
        this.$message.error('文件大小不应超过 5MB！')
      } else if (this.language === 'zh_tw') {
        this.$message.error('文件大小不應超過 5MB！')
      }
    }
    return isLt5M
  }

  // oss配置
  private async getOssPlict() {
    try {
      getOssPlicy().then((res: any) => {
        const {
          expiration,
          access_key_secret,
          access_key,
          sts_token,
          upload_dir,
          bucket,
          region
        } = res
        this.ossParams = {
          secure: true,
          region: region,
          bucket: bucket,
          accessKeyId: access_key,
          accessKeySecret: access_key_secret,
          stsToken: sts_token
        }
        this.uploadDir = upload_dir
      })
    } catch (e) {}
  }

  mounted() {
    this.getOssPlict()
  }

  created() {
    if (this.attachUrl) {
      this.attachUrl.map((item: any) => {
        let attachObj = {
          url: ''
        }
        attachObj.url = item
        this.fileList.push(attachObj)
      })
    }
  }
}
